<h3 mat-dialog-title class="d-flex justify-content-between align-items-center">
    <span>{{ paymentGroup ? 'Payments Details for ' + paymentGroup.payor.name : 'Loading Payment' }}</span>
    <app-entity-history-button
        *ngIf="paymentGroup"
        subjectType="payment"
        [subjectId]="paymentGroup.id"
        [subjectLabel]="'Payment ' + paymentGroup.id"
        [canView]="jwt?.superUser"
        [showSuperStar]="true"
        variant="v1">
    </app-entity-history-button>
</h3>

<mat-dialog-content>
    <ng-template #loading>
        <div class="px-3 py-4 d-flex justify-content-center">
            <mat-spinner [color]="'accent'"></mat-spinner>
        </div>
    </ng-template>

    <ng-container *ngIf="paymentGroup; else loading">
        <div class="card">
            <div class="card-header justify-content-between d-flex">
                <h2>Payment Details</h2>
                <span *ngIf="paymentGroup.autopaid" class="autopaid-tag">{{ 'Autopaid' }}</span>
            </div>
            <div class="card-body">
                <div class="grid-layout grid-3 mt-0">
                    <div>
                        <label>Payment Date</label>
                        <div [innerHTML]="paymentGroup.createdAt | legfiDate:'MM/DD/YYYY'"></div>
                    </div>

                    <div *ngIf="paymentGroup.payorType.indexOf('Owner') !== -1">
                        <label>Payor</label>
                        <div>
                            {{ paymentGroup.payor.name }}
                        </div>
                    </div>

                    <div>
                        <label>Payment Method</label>
                        <div *ngIf="paymentGroup.paymentMethodType !== 'AccountCredit'">
                            {{ paymentGroup.friendlyPaymentMethod }}
                        </div>
                        <div matTooltip="Credit granted by admin" *ngIf="paymentGroup.paymentMethodType === 'AccountCredit' && !paymentGroup.paymentThatBoughtCredit">
                            {{ paymentGroup.friendlyPaymentMethod }}
                        </div>
                        <button class="btn btn-link p-0 d-block" matTooltip="View payment that purchased this credit" *ngIf="paymentGroup.paymentMethodType === 'AccountCredit' && paymentGroup.paymentThatBoughtCredit" (click)="openParentPayment(paymentGroup.paymentThatBoughtCredit)">
                            {{ paymentGroup.friendlyPaymentMethod }}
                        </button>
                    </div>

                    <div *ngIf="paymentGroup.createdBy">
                        <label>Recorded By</label>
                        <div>{{ paymentGroup.createdBy.name }}</div>
                    </div>

                    <div *ngIf="paymentGroup.createdBy">
                        <label>Recorded At</label>
                        <div>{{ paymentGroup.importedAt | legfiDate:'MM/DD/YYYY h:mm a' }}</div>
                    </div>

                    <div *ngIf="paymentGroup.deletedBy">
                        <label>Deleted By</label>
                        <div>{{ paymentGroup.deletedBy.name }}</div>
                    </div>

                    <div *ngIf="fundsAvailable">
                        <label>Funds Available</label>
                        <div *ngIf="fundsAvailable === 'N/A'">
                            N/A
                        </div>
                        <div *ngIf="fundsAvailable !== 'N/A'">
                            {{ fundsAvailable | legfiDate:'MM/DD/YYYY' }}
                        </div>
                    </div>

                    <div>
                        <label>Amount Paid</label>
                        <div>
                            <ng-container *ngIf="paymentGroup.refundedAmount > 0; else fullAmountPaid">
                                {{ paymentGroup.gross | legfiCurrency:'USD':'symbol':'.2' }}
                                <small class="text-muted d-block">
                                    <span style="text-decoration: line-through">{{ paymentGroup.originalGross | legfiCurrency:'USD':'symbol':'.2' }}</span>
                                    &minus; {{ paymentGroup.refundedAmount | legfiCurrency:'USD':'symbol':'.2' }} refunded
                                </small>
                            </ng-container>
                            <ng-template #fullAmountPaid>
                                {{ paymentGroup.gross | legfiCurrency:'USD':'symbol':'.2' }}
                            </ng-template>
                        </div>
                    </div>

                    <div *ngIf="paymentGroup.absorbedFees">
                        <label>Absorbed Fees</label>
                        <div>
                            {{ paymentGroup.absorbedFees | legfiCurrency:'USD':'symbol':'.2' }}
                        </div>
                    </div>

                    <div *ngIf="paymentGroup.offloadedFees">
                        <label>Offloaded Fees</label>
                        <div>
                            {{ paymentGroup.offloadedFees | legfiCurrency:'USD':'symbol':'.2' }}
                        </div>
                    </div>

                    <div>
                        <label>Net Amount</label>
                        <div>
                            <ng-container *ngIf="paymentGroup.refundedAmount > 0; else fullNet">
                                {{ paymentGroup.net | legfiCurrency:'USD':'symbol':'.2' }}
                                <small class="text-muted d-block">
                                    <span style="text-decoration: line-through">{{ paymentGroup.originalNet | legfiCurrency:'USD':'symbol':'.2' }}</span>
                                    &minus; {{ paymentGroup.refundedAmount | legfiCurrency:'USD':'symbol':'.2' }} refunded
                                </small>
                            </ng-container>
                            <ng-template #fullNet>
                                {{ paymentGroup.net | legfiCurrency:'USD':'symbol':'.2' }}
                            </ng-template>
                        </div>
                    </div>

                    <div *ngIf="paymentGroup.payorType.indexOf('Owner') !== -1 || paymentGroup.payorType.indexOf('Unit') !== -1">
                        <label>Unit</label>
                        <div>
                            <ng-container *ngIf="paymentGroup.payorType.indexOf('Unit') !== -1">
                                <a [routerLink]="['/app/unit/detail/' + paymentGroup.payorId]">
                                    {{ paymentGroup.payor.title }}
                                </a>
                                {{ paymentGroup.payor.addressString }}
                            </ng-container>

                            <ng-container *ngIf="paymentGroup.payorType.indexOf('Owner') !== -1">
                                <a [routerLink]="['/app/unit/detail/' + paymentGroup.payor.unitId]">{{ paymentGroup.payor.unit.name }}</a>
                                <br>
                                {{ paymentGroup.payor.unit.addressString }}
                            </ng-container>
                        </div>
                    </div>

                    <div *ngIf="paymentGroup.paymentAttempts[0].transactions.length > 0">
                        <label>Deposit Transaction</label>
                        <div>
                            <button *ngIf="hasTransactionsPermission" class="btn btn-link m-0 p-0" (click)="openDepositTransactionDetails()">
                                "{{ paymentGroup.paymentAttempts[0].transactions[0].description }}"
                                on
                                {{ paymentGroup.paymentAttempts[0].transactions[0].transactionDate | legfiDate:'MM/DD/YYYY' }}
                            </button>

                            <span *ngIf="!hasTransactionsPermission">
                                "{{ paymentGroup.paymentAttempts[0].transactions[0].description }}"
                                on
                                {{ paymentGroup.paymentAttempts[0].transactions[0].transactionDate | legfiDate:'MM/DD/YYYY' }}
                            </span>
                        </div>
                    </div>

                    <div *ngIf="accrualAccounting && paymentGroup.paymentAttempts[0]?.openingBalance">
                        <label>Starting Balance</label>
                        <div>
                            Starting Balance credits are posted to Opening Balance Equity.
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="paymentGroup && (paymentGroup.notes && paymentGroup.notes.length)"
             class="card">
            <div class="card-header">
                <h2>Notes</h2>
            </div>
            <div class="card-body p-0">
                <table class="table m-0">
                    <thead>
                    <tr>
                        <th class="notes-date-column">Created</th>
                        <th>Note</th>
                    </tr>
                    </thead>
                    <tbody>
                    <!--suppress HtmlUnknownAttribute -->
                    <ng-template [ngForOf]="paymentGroup.notes" let-note ngFor>
                        <!--suppress HtmlUnknownAttribute -->
                        <tr>
                            <td data-label="Created">
                                {{ note.createdAt | legfiDate:'MM/DD/YYYY' }}
                            </td>
                            <td data-label="Note">
                                {{ note.note }}
                            </td>
                        </tr>
                    </ng-template>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="card" *ngIf="paymentGroup.refundedAmount > 0">
            <div class="card-header d-flex justify-content-between">
                <h2>Refunds</h2>
                <h2 class="mr-4">
                    {{ paymentGroup.refundedAmount | legfiCurrency:'USD':'symbol':'.2' }} refunded
                </h2>
            </div>
            <div class="card-body p-0">
                <table class="table m-0">
                    <thead>
                    <tr>
                        <th>Refund Date</th>
                        <th>Stripe Refund ID</th>
                        <th class="text-right">Amount</th>
                    </tr>
                    </thead>
                    <tbody>
                    <ng-template [ngForOf]="paymentGroup.paymentAttempts" let-attempt ngFor>
                        <ng-template [ngForOf]="attempt.stripeRefunds" let-refund ngFor>
                            <tr>
                                <td data-label="Refund Date">{{ refund.createdAt | legfiDate:'MM/DD/YYYY' }}</td>
                                <td data-label="Stripe Refund ID"><code>{{ refund.stripeRefundId }}</code></td>
                                <td data-label="Amount" class="text-right">
                                    {{ refund.amount | legfiCurrency:'USD':'symbol':'.2' }}
                                </td>
                            </tr>
                        </ng-template>
                    </ng-template>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="card">
            <div class="card-header d-flex justify-content-between">
                <h2>Payment Application</h2>
                <button (click)="issueDifferenceCredit()" *ngIf="jwt.superUser && totalShort > 0" [disabled]="this.inFlightRequest" class="btn btn-outline-secondary">
                    Credit Missing {{ totalShort | legfiCurrency:'USD':'symbol':'.2' }}
                    <app-super-star></app-super-star>
                </button>
            </div>
            <div class="card-body p-0">
                <table class="table m-0">
                    <thead>
                    <tr>
                        <th>Active Date</th>
                        <th>Due Date</th>
                        <th>Charge Title</th>
                        <th *ngIf="[2400,2401,2402].includes(paymentGroup.organizationId)">Charge Description</th>
                        <th class="text-right">Amt Paid</th>
                        <th *ngIf="paymentGroup.organizationId !== 2401">Deposit Account</th>
                        <th>Budget Category</th>
                    </tr>
                    </thead>
                    <tbody>
                    <!--suppress HtmlUnknownAttribute -->
                    <ng-template *ngIf="paymentGroup" [ngForOf]="paymentGroup.chargesPaid" let-item ngFor>
                        <!--suppress HtmlUnknownAttribute -->
                        <tr *ngIf="item && item.payable && item.payableType.indexOf('Subscription') === -1 && item.payableType.indexOf('Product') === -1 && item.amount > 0">
                            <td data-label="Active Date">
                                {{
                                    (item.payable && item.payable.activeAfter ? item.payable.activeAfter : item.createdAt) |
                                        legfiDate:'MM/DD/YYYY'
                                }}
                            </td>
                            <td data-label="Due Date">
                        <span *ngIf="item.payable && item.payable.paymentDueOn">
                            {{ item.payable.paymentDueOn | legfiDate:'MM/DD/YYYY' }}
                        </span>
                            </td>
                            <td data-label="Charge Title">
                                <span *ngIf="item.payableType.indexOf('AccountCredit') !== -1">
                                    Account Credit
                                    <button type="button" class="btn btn-link p-0" (click)="restoreCredit(item.payable.ownerId, item.payable.id)" *ngIf="jwt.superUser && item.payable.deletedAt">Restore <app-super-star></app-super-star></button>
                                </span>
                                <span *ngIf="item.payableType.indexOf('FundingAttempt') !== -1">
                        Mailed Payment for {{ item.payable.organization.name }}
                    </span>
                                <span
                                    *ngIf="item.payableType.indexOf('AccountCredit') === -1 && item.payableType.indexOf('FundingAttempt') === -1">
                        {{ item.payable.title }}
                    </span>
                            </td>
                            <td *ngIf="[2400,2401,2402].includes(paymentGroup.organizationId)">{{ item.payable.description }}</td>
                            <td data-label="Amt Paid" class="text-right">
                                {{ (item.amount) | legfiCurrency:'USD':'symbol':'.2' }}
                            </td>
                            <td *ngIf="paymentGroup.organizationId !== 2401" data-label="Deposit Account">
                    <span *ngIf="item.payable.depositBankAccount"
                          [innerHTML]="item.payable.depositBankAccount.friendlyName">
                    </span>
                                <span *ngIf="!(item.payable.depositBankAccount)">
                        N/A
                    </span>
                            </td>
                            <td data-label="Budget Category">
                    <span *ngIf="item.payable.category">
                        {{ item.payable.category.name }}
                        <span *ngIf="item.payable.category.deletedAt">(deleted)</span>
                    </span>
                                <span *ngIf="!(item.payable.category)">
                        N/A
                    </span>
                            </td>
                        </tr>
                    </ng-template>
                    </tbody>
                    <tfoot>
                    <tr>
                        <th [attr.colspan]="[2400,2401,2402].includes(paymentGroup.organizationId) ? 4 : 3">
                            Total Charges Paid
                        </th>
                        <th class="text-right">{{ paymentGroup.chargesPaid | sum:'amount' | legfiCurrency:'USD':'symbol':'.2' }}</th>
                        <th [attr.colspan]="paymentGroup.organizationId !== 2401 ? 2 : 1"></th>
                    </tr>
                    <tr *ngIf="paymentGroup?.creditsPurchased?.length">
                        <th [attr.colspan]="[2400,2401,2402].includes(paymentGroup.organizationId) ? 4 : 3">
                            Account Credit Added
                        </th>
                        <th class="text-right">{{ paymentGroup.creditsTotal | legfiCurrency:'USD':'symbol':'.2' }}</th>
                        <th [attr.colspan]="paymentGroup.organizationId !== 2401 ? 2 : 1"></th>
                    </tr>
                    <tr *ngIf="paymentGroup?.creditsPurchased?.length">
                        <th [attr.colspan]="[2400,2401,2402].includes(paymentGroup.organizationId) ? 4 : 3">
                            Account Credit Remaining
                        </th>
                        <th class="text-right">{{ paymentGroup.creditRemaining | legfiCurrency:'USD':'symbol':'.2' }}</th>
                        <th [attr.colspan]="paymentGroup.organizationId !== 2401 ? 2 : 1"></th>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </div>

        <div class="card" *ngIf="paymentGroup?.creditUsages?.length">
            <div class="card-header d-flex justify-content-between">
                <h2>Credit Application</h2>
                <h2 class="mr-4">
                    {{ paymentGroup.creditRemaining | legfiCurrency:'USD':'symbol':'.2' }} Remaining
                </h2>
            </div>
            <div class="card-body p-0" *ngIf="paymentGroup.creditUsages.length > 0">
                <table class="table m-0">
                    <thead>
                    <tr>
                        <th>Usage Date</th>
                        <th class="text-right">Used Amount</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <!--suppress HtmlUnknownAttribute -->
                    <ng-template *ngIf="paymentGroup" [ngForOf]="paymentGroup.creditUsages" let-item ngFor>
                        <!--suppress HtmlUnknownAttribute -->
                        <tr>
                            <td data-label="Payment Date">
                                {{ item.importedAt | legfiDate:'MM/DD/YYYY' }}
                            </td>
                            <td data-label="Payment Amount" class="text-right">
                                {{ (item.applied) | legfiCurrency:'USD':'symbol':'.2' }}
                            </td>
                            <td>
                                <button class="btn btn-link p-0" (click)="openParentPayment(item.id)">
                                    View Payment
                                </button>
                            </td>
                        </tr>
                    </ng-template>
                    </tbody>
                    <tfoot>
                    <tr>
                        <th>Total</th>
                        <th class="text-right">{{ paymentGroup.creditUsages | sum:'applied' | legfiCurrency:'USD':'symbol':'.2' }}</th>
                        <th></th>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </div>

        <div class="card" *ngIf="hasAccountingV2 && jwt.admin && paymentGroup?.ledgerEntries?.length">
            <div class="card-header d-flex justify-content-between">
                <h2>Ledger Entries</h2>
            </div>
            <div class="card-body p-0">
                <table class="table m-0">
                    <thead>
                    <tr>
                        <th>Entry Date</th>
                        <th>Account</th>
                        <th class="text-right">Debit</th>
                        <th class="text-right">Credit</th>
                    </tr>
                    </thead>
                    <tbody>
                    <!--suppress HtmlUnknownAttribute -->
                    <ng-template [ngForOf]="paymentGroup.ledgerEntries | groupBy:'batchId'" let-group ngFor>
                        <tr>
                            <td colspan="2" matTooltip="Created {{group[0].createdAt | legfiDate}}">
                                {{ group[0].description }}
                            </td>
                            <td colspan="2" class="text-right">
                                <button class="btn btn-link p-0 m-0" *ngIf="jwt.superUser" (click)="deleteLedgerBatch(group[0].batchId)">
                                    Delete Batch
                                    <app-super-star></app-super-star>
                                </button>
                            </td>
                        </tr>
                        <ng-template [ngForOf]="group" let-item ngFor>
                            <!--suppress HtmlUnknownAttribute -->
                            <tr>
                                <td>
                                    {{ item.entryDate | legfiDate }}
                                </td>
                                <td>
                                    {{ item.account.name }}
                                </td>
                                <td class="text-right">
                                    {{ item.debit | legfiCurrency }}
                                </td>
                                <td class="text-right">
                                    {{ item.credit | legfiCurrency }}
                                </td>
                            </tr>
                        </ng-template>
                    </ng-template>
                    </tbody>
                    <tfoot>
                    <tr>
                        <th>Total</th>
                        <th></th>
                        <th class="text-right">{{ paymentGroup.ledgerEntries | sum:'debit' | legfiCurrency }}</th>
                        <th class="text-right">{{ paymentGroup.ledgerEntries | sum:'credit' | legfiCurrency }}</th>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </ng-container>
</mat-dialog-content>

<mat-dialog-actions>
    <app-button mat-dialog-close>{{ 'Close' }}</app-button>
</mat-dialog-actions>
